import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Select, Form, DatePicker, Image, Avatar, Button, Row, Col, Upload, message } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const ModalBody = ({close, handleSubmit, sticker, update}) => {
    const [name, setName] = useState('');
    const [sortIndex, setSortIndex] = useState(0);
    const [loading, setLoading] = useState(false);

    const [form] = Form.useForm();
    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

    useEffect(() => {
        if(!sticker){
            setName("");
            setSortIndex(0);
            form.setFieldsValue({
                name: "",
                sortIndex: 0
            })
            
            return;
        }

        setName(sticker.Name);
        setSortIndex(sticker.SortIndex);
        form.setFieldsValue({
            name: sticker.Name,
            sortIndex: sticker.SortIndex
        })
    }, [update])

    const onFinish = (values) => {
        handleSubmit({
            name: name,
            sortIndex: sortIndex
        })
    }

    return (
        <Form onFinish={onFinish} form={form}>
            <div className="form form--horizontal">
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                        <Form.Item name="name" label="Name"
                            rules={[
                                {
                                    required: true,
                                    message: `Name is required!`,
                                },
                            ]}>
                            <input
                                name="name"
                                type="name"
                                value={name}
                                placeholder="Name"
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="sortIndex" label="Sort Index">
                            <input
                                name="name"
                                type="number"
                                placeholder="Name"
                                value={sortIndex}
                                onChange={(e) => setSortIndex(e.target.value)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>
            <Row style={{justifyContent: 'center'}}>
                <Button type="text" onClick={close}>Cancel</Button>
                <Button type="primary" htmlType="submit">{sticker ? 'Update' : 'Add'}</Button>
            </Row>
        </Form>
        
    )
}

export default ModalBody;